'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'plane';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f072';
var svgPathData = ['M144 16l61.3 184 187.3 0-168.7-184-80 0zm0 480l80 0 168.7-184-187.3 0-61.3 184z', 'M520 200c30.9 0 56 25.1 56 56s-25.1 56-56 56l-414.4 0-57.6 72-48 0 32-128-32-128 48 0 57.6 72 414.4 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;